import { useEffect } from 'react';
import socket from './index';
import { SocketAppEvent } from './socket.type';

type ChatService = {
  channel: string;
  onHandle: (event: SocketAppEvent) => void;
};

export const useSocketClient = (props: ChatService) => {
  useEffect(() => {
    socket.on(props.channel, props.onHandle);
    return () => {
      socket.disconnect();
    };
  }, []);
};
